import React, { FC } from 'react'
import { Box, Chip, FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from '@mui/material'
import { useQueryParams } from 'src/hooks/ui'
import { SearchParamsKeys } from 'src/enums'
import { configTypeFilterOptions } from 'src/components/sections/sensor/sensorConfigurationAnalytics/configTypes'

export const ConfigurationAnalyticsFilters: FC = () => {
  const [queryParams, setQueryParams] = useQueryParams()

  // Value is driven directly by the URL (single source of truth), so external
  // param changes (e.g. browser back/forward) stay reflected in the control.
  const value = queryParams[SearchParamsKeys.ConfigType] || 'all'

  const handleConfigTypeChange = (event: SelectChangeEvent<string>) => {
    const nextValue = event.target.value
    // Always reset to page 1 by writing Page rather than removing it — removing
    // Page would make the table re-seed its defaults and reset the page size.
    setQueryParams(
      {
        [SearchParamsKeys.Page]: '1',
        ...(nextValue === 'all' ? {} : { [SearchParamsKeys.ConfigType]: nextValue })
      },
      [SearchParamsKeys.ConfigType]
    )
  }

  return (
    <Grid container alignItems="center" spacing={{ xs: 0, sm: 2 }}>
      <Grid item xs={12} sm="auto">
        <FormControl sx={{ m: 1, width: { xs: '100%', sm: 400 } }}>
          <InputLabel id="config-type-chip-label">Configuration type</InputLabel>
          <Select
            labelId="config-type-chip-label"
            id="config-type-chip"
            value={value}
            onChange={handleConfigTypeChange}
            input={<OutlinedInput id="config-type-select-chip" label="Configuration type" />}
            renderValue={(selected) => {
              const item = configTypeFilterOptions.find((o) => o.value === selected)
              return (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  <Chip key={item?.value} label={item?.name} />
                </Box>
              )
            }}
          >
            {configTypeFilterOptions.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  )
}
